/* eslint-disable camelcase */

export const Sticker = {
    open: false,
    defaultGroup: 'recent',
    baseurl: '//t1.daumcdn.net/brunch/static/img/sticker',
    stickerUrlRegExp: new RegExp('.daumcdn.net/brunch/static/img/sticker/(.*).png'),
    groups: {
        recent: {},
        apeach: {
            muzi: 32,
            apeach: 24,
        },
        frodo: {
            frodo: 23,
            neo: 24,
        },
        'jay-g': {
            'jay-g': 24,
            tube: 24,
        },
        frodo_neo: {
            frodo_neo: 9,
        },
    },
};
